// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"053eea27","310":"d5c4fcf7","423":"e0c3e20d","626":"70870e86","732":"b5e5bb6d","767":"5e3f10ed","835":"686c0713","911":"c9966c07","979":"fdd94661"}[chunkId] + ".chunk.js";
};